import { Link } from 'react-router-dom'

import styles from './gnb.module.scss'
// import NavBar from './NavBar'

const GNB = () => {
  return (
    <header className={styles.gnb}>
      <div className={styles.headerWrapper}>
        <div className={styles.logoWrapper}>
          {/* <Link to='/'>여울 & 우신</Link> */}
          <Link to='/' style={{ color: '#812808' }}>
            26.1.24 토 15:00 동서울웨딩컨벤션 그랜드볼룸
          </Link>
        </div>
        {/* <div className="p-4 text-red-500">
          <Link to='/'>여울 & 우신</Link>
        </div> */}
        {/* <NavBar /> */}
      </div>
    </header>
  )
}

export default GNB
